import { KlarnaJS } from '@klarna/web-sdk-types'
import type SDK from '@klarna-web-sdk/lib/src/sdk'
import { store } from '@klarna-web-sdk/payment/src/utils/store'
import { ErrorCodes, ErrorTypes } from '@klarna-web-sdk/utils'
import { SDKConfig } from '@klarna-web-sdk/utils/src/types'

import { ConfigError } from './utils/configError'

export class KlarnaConfig {
  private sdkInstance: SDK
  private sdkConfig: SDKConfig

  constructor(sdk: SDK, sdkConfig: SDKConfig) {
    this.sdkInstance = sdk
    this.sdkConfig = sdkConfig
  }

  private setAccountId = async (accountId: string) => {
    this.sdkConfig.accountId = accountId
    store.set('config', { ...this.sdkConfig, accountId })
  }

  private setSdkToken = async (sdkToken: string) => {
    if (!sdkToken || typeof sdkToken !== 'string') {
      throw new ConfigError(ErrorTypes.INPUT_ERROR, ErrorCodes.VALIDATION_ERROR, 'Invalid sdkToken')
    }
    this.sdkInstance.Shopping.resumeSessionWithSdkToken(sdkToken)
  }

  /**
   * @hidden
   */
  getPublicAPI(): KlarnaJS['Config'] {
    return {
      setAccountId: this.setAccountId.bind(this),
      setSdkToken: (sdkToken) => this.setSdkToken(sdkToken),
    }
  }
}

export type KlarnaConfigPublicAPI = ReturnType<typeof KlarnaConfig.prototype.getPublicAPI>
